import React, { PureComponent, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getRequestsSolicitation, changePage, changePerPage, onChangeSort, resetRequests } from './actions';
import { setFilter } from '../table/actions';
import { getRequestsList, getLoadingStatus } from './selector';

import LocacoesTableView from './LocacoesTableView';
import RequestsHeader from '../../../components/Operational/RequestsHeader';
import RequestLine from '../../../components/Operational/RequestLine';
import PaginationFooter from '../../../components/shared/table/PaginationFooter';
import {
  RequestsTableCard,
  RequestsTableCardFooter
} from '../requestsPage.styles';

class RequestsTable extends PureComponent {
  state = {
    current: 'id',
    sort: 'ASC'
  }

  componentDidMount() {
    this.props.setFilter("");
    this.props.getRequestsSolicitation();
  }

  componentWillUnmount() {
    this.props.resetRequests();
  }

  onChangePage = (page) => {
    this.props.changePage(page);
    this.props.getRequestsSolicitation();
  }

  onChangeResultsperPage = (perPage) => {
    this.props.changePerPage(perPage);
    localStorage.setItem("resultsPerPageRequests", perPage);
    this.props.getRequestsSolicitation();
  }

  changeCurrentSort = (name) => {
    const { current, sort } = this.state;
    let newSort = '';
    if (current === name) {
      newSort = sort === "ASC"? 'DESC' : 'ASC';
    } else {
      newSort = 'ASC';
    }
    this.setState({ current: name, sort: newSort }, () => {
      const apiSort = (newSort === "DESC")? `-${name}` : name;
      this.props.onChangeSort(apiSort);
      this.props.getRequestsSolicitation();
    });
  }

  renderHeader = () => (
    <RequestsHeader
      sortHandler={this.changeCurrentSort}
      current={this.state.current}
      sort={this.state.sort}
      modern
    />
  );

  renderLine = (line, index) => {
    const onGoToResume = () => {
      this.props.setFilter("");
      this.props.history.push({
        pathname: '/intranet/operacional/solicitacao/resumo',
        state: { request: line.id }
      })
    };
    
    return (
      <RequestLine
        key={line.id.toString()}
        {...line}
        index={index}
        length={this.props.lines.length}
        onGoToResume={onGoToResume}
        modern
      />
    );
  }

  render() {
    return (
      <Fragment>
        <RequestsTableCard>
          <LocacoesTableView
            loading={this.props.requesting}
            lines={this.props.lines}
            renderHeader={this.renderHeader}
            renderLine={this.renderLine}
          />
          <RequestsTableCardFooter>
            <PaginationFooter
              pagination={this.props.pagination}
              changePage={this.onChangePage}
              changeMaxResults={this.onChangeResultsperPage}
              callToAction={this.props.callToAction}
              allowMaxPerPage={true}
            />
          </RequestsTableCardFooter>
        </RequestsTableCard>
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({ getRequestsSolicitation, changePage, changePerPage, onChangeSort, setFilter, resetRequests }, dispatch);

const mapStateToProps = (state) => ({
  lines: getRequestsList(state),
  requesting: getLoadingStatus(state),
  pagination: state.requestsTable.pagination
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RequestsTable));
